import React from "react";
import Reveal from "./Reveal";

const PILLARS = [
  {
    title: "Personalized Representation",
    desc: "Boutique-firm focus. Your case is handled with the care it deserves — never passed off to a junior associate.",
  },
  {
    title: "Direct Access To Your Attorney",
    desc: "Every client receives a direct line. No layers of staff between you and the lawyer fighting for you.",
  },
  {
    title: "10+ Years of Experience",
    desc: "A decade of personal injury practice across Florida and Texas — with millions recovered for injured clients.",
  },
  {
    title: "Free, No-Obligation Consultation",
    desc: "Available 24/7 by phone, video, or in person. You owe nothing unless we win your case.",
  },
];

export default function WhyChoose() {
  return (
    <section
      data-testid="why-choose-section"
      className="relative bg-[#0F2240] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-32">
          <Reveal>
            <div className="flex items-center gap-3 mb-5">
              <div className="h-px w-10 bg-[#B89968]" />
              <span className="text-[#B89968] text-xs uppercase tracking-[0.32em]">
                Why Newman Injury Law
              </span>
            </div>
            <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
              The care and attention <span className="italic gold-text">you deserve</span> when you're injured.
            </h2>
            <p className="mt-6 text-[#CBD5E1] text-lg leading-relaxed max-w-md">
              There is nothing more personal than a serious injury. When you
              hire Newman Injury Law, you get an attorney who treats your case
              like it matters — because it does.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-7 space-y-px bg-[#B89968]/15">
          {PILLARS.map((p, i) => (
            <Reveal
              key={p.title}
              delay={i * 80}
              className="bg-[#0F2240] hover:bg-[#15294C] transition-colors duration-500 p-8 md:p-10 group"
              data-testid={`pillar-${i}`}
            >
              <div className="flex items-start gap-6">
                <div className="font-serif-display text-2xl text-[#B89968] leading-none w-8 mt-1">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="flex-1">
                  <h3 className="font-serif-display text-xl md:text-2xl text-white mb-3">
                    {p.title}
                  </h3>
                  <p className="text-[#94A3B8] leading-relaxed">{p.desc}</p>
                </div>
                <span className="text-[#B89968]/40 group-hover:text-[#B89968] transition-colors text-lg">
                  →
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
